import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import styled from "styled-components";
import { SimplePaginationItemContainer } from "./simple-pagination-item.styles";
import { KeyBoardKeys } from "../dropdown/keyboardkeys";
const StyledDiv = styled.div `
  width: 1.5rem;
  text-align: center;
`;
const StyledStepDiv = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: auto;
  margin: 0 0.5rem;
  text-align: center;
`;
export function SimplePaginationItem({ step, totalItems, onChange, onEnter, previewId, }) {
    const [isTabFocused, setIsTabFocused] = useState(false);
    const [isMouseFocused, setIsMouseFocused] = useState(false);
    const [selected, setSelected] = useState(false);
    return (_jsxs(StyledStepDiv, Object.assign({ "data-preview-id": previewId }, { children: [_jsx(SimplePaginationItemContainer, { onChange: (e) => {
                    onChange(Number(e.target.value));
                }, onFocus: () => setSelected(true), onMouseUp: () => setIsMouseFocused(false), onMouseDown: () => setIsMouseFocused(true), onKeyUp: (e) => {
                    if (e.key === KeyBoardKeys.Enter ||
                        e.key === KeyBoardKeys.Space ||
                        e.key === " ") {
                        onEnter();
                    }
                    if (e.key === KeyBoardKeys.Tab) {
                        setIsTabFocused(true);
                    }
                }, onKeyDown: (e) => {
                    if (e.key === KeyBoardKeys.Tab) {
                        setIsTabFocused(false);
                    }
                }, onBlur: () => setSelected(false), isTabFocused: isTabFocused, isMouseFocused: isMouseFocused, value: step, selected: selected }), _jsx(StyledDiv, { children: "/" }), _jsx("div", { children: totalItems })] })));
}
